var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 15.889,
    viewBox: "0 0 22 15.889",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-bars",
    d: "M21.083,124.5H.917a.917.917,0,1,1,0-1.833H21.083a.917.917,0,1,1,0,1.833Zm0,0",
    transform: "translate(0 -115.64)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon-bars",
    d: "M21.083,1.833H.917A.917.917,0,0,1,.917,0H21.083a.917.917,0,0,1,0,1.833Zm0,0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "icon-bars",
    d: "M21.083,247.165H.917a.917.917,0,0,1,0-1.833H21.083a.917.917,0,0,1,0,1.833Zm0,0",
    transform: "translate(0 -231.277)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuClose);
export default __webpack_public_path__ + "static/media/menu-close.cd22c8f73a1c9f8b0f04518733e8a3c8.svg";
export { ForwardRef as ReactComponent };